var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgControlPoint(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_593_2780)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9168 6.41671H10.0835V10.0834H6.41683V11.9167H10.0835V15.5834H11.9168V11.9167H15.5835V10.0834H11.9168V6.41671ZM11.0002 1.83337C5.94933 1.83337 1.8335 5.94921 1.8335 11C1.8335 16.0509 5.94933 20.1667 11.0002 20.1667C16.051 20.1667 20.1668 16.0509 20.1668 11C20.1668 5.94921 16.051 1.83337 11.0002 1.83337ZM11.0002 18.3334C6.95766 18.3334 3.66683 15.0425 3.66683 11C3.66683 6.95754 6.95766 3.66671 11.0002 3.66671C15.0427 3.66671 18.3335 6.95754 18.3335 11C18.3335 15.0425 15.0427 18.3334 11.0002 18.3334Z",
    fill: "#8C8C8C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_593_2780"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgControlPoint);
export default __webpack_public_path__ + "static/media/control-point.d96b644faad13707ff2a58f3425c460a.svg";
export { ForwardRef as ReactComponent };